import { FC } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { DialogProps } from '../../../core/providers/dialog.provider';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { ClientInfoTherapyTitleApi } from '../../../core/http';
import { useEditResource } from '../../../core/hooks/useEditResource';
import * as yup from 'yup';
import { TextField } from '../../../components/fields';

interface EditDialogProps extends DialogProps {
  uuid?: string;
  onSuccess?: (values) => void;
  onError?: (error) => void;
}

const appointmentCancelTypeApi = new ClientInfoTherapyTitleApi();

export const ClientInfoTherapyTitleEditDialog: FC<EditDialogProps> = ({
  popDialog,
  uuid,
  onSuccess,
  onError
}) => {
  const {
    isEdit,
    isLoading,
    handleSubmit,
    handleChange,
    values,
    getFieldTouchedError
  } = useEditResource(appointmentCancelTypeApi, {
    uuid,
    initialValues: {
      title: ''
    },
    validationSchema: yup.object().shape({
      title: yup.string().required('Title is a required field')
    }),
    onSuccess,
    onError
  });

  return (
    <Dialog open onClose={popDialog}>
      <DialogTitle>{isEdit ? 'Edit record' : 'Add new record'}</DialogTitle>
      <DialogContent sx={{ pb: 1.5 }}>
        <TextField
          label="Client-info Therapy Title"
          value={values.title}
          onChange={handleChange('title')}
          errors={getFieldTouchedError('title')}
        />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={popDialog}>
          Cancel
        </Button>
        <Button disabled={isLoading} onClick={() => handleSubmit()}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
